import { z } from 'zod';

export const performanceComparisonBarSchema = z.object({
  rotulo: z.string(),
  pontuacao: z.number().nullish(),
});

export type PerformanceComparisonBar = z.infer<typeof performanceComparisonBarSchema>;

export const performanceComparisonResponseSchema = z.object({
  barras: z.array(performanceComparisonBarSchema).nullish(),
  interpretacao: z.string().optional(),
});

export type PerformanceComparisonResponse = z.infer<typeof performanceComparisonResponseSchema>;
